<template>
  <div class="width-100" style="">
    <div class="width-100 part1 flex-row justify-content-center align-items-center">
      <div class="white fs-sml pointer" @click="jumpTo('/law')">法律声明</div>
      <div class="cutLine-v margin-l margin-r"></div>
      <div class="white fs-sml pointer" @click="jumpTo('/map')">网站地图</div>
      <div class="cutLine-v margin-l margin-r"></div>
      <div class="white fs-sml pointer" @click="jumpTo('/contactUs')">联系我们</div>
      <div class="cutLine-v margin-l margin-r"></div>
      <div class="white fs-sml pointer" @click="jumpTo('/friendlyLink')">友情链接</div>
    </div>
    <div class="width-100 part2 flex-column justify-content-start align-items-center">
      <p class="white fs-sml lineHeight2">版权所有©国有资产投资集团有限公司</p>
      <p class="white fs-sml lineHeight2">技术支持：瑞安市数据管理发展有限公司</p>
      <div class="flex-row justify-content-center align-items-center">
        <img src="@/assets/image/icon.png" height="18" alt="" />
        <p @click="jump('https://beian.miit.gov.cn/')" class="grey fs-sml lineHeight2 margin-ls pointer">
          浙公网安备33038102331093 浙ICP备13003470号-1
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HelloWorld',
  components: {},
  data() {
    return {};
  },
  mounted() {},

  created() {},
  methods: {
    jumpTo(url) {
      let text = this.$router.resolve({ path: url });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    },
    jump(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.cutLine-v {
  height: 16px;
  width: 1px;
}
.part1 {
  padding: 10px 0;
  background: rgb(105, 105, 105);
}
.part2 {
  padding: 20px 0;
  background: rgb(51, 51, 51);
}
</style>
